export const API_BASE_URL = '/api/v1';
export const prefixAPI = url => API_BASE_URL + url;

export const LOGOUT_URL = '/auth/logout/';
